import React from "react";
import classes from './text.module.css';

const TextOption = (props) => {
    return (
        <p><span>{props.post.id}</span>{props.post.body}</p>
    )
}

export default TextOption;